module.exports = "<html>\n  <body>\n    <canvas id='container' class='myCanvas'></canvas>\n  </body>\n</html>\n"